import {Breadcrumb} from "antd";
import {Link} from "react-router-dom";
import {StyledPageWrapper} from "../../../../styles/dashboard/calls/calls";
import {FormWrapper, FormWrapperProps} from "../../../../components/form-wrapper";
import {useGetDiscountCodeContext} from "../context";

export function EditDiscountPageLayout({title, children}: FormWrapperProps) {
  const {
    state: {
      discountCodeData: {
        discount: {code},
      },
    },
  } = useGetDiscountCodeContext();
  return (
    <>
      <Breadcrumb>
        <Breadcrumb.Item>
          <Link to="/discounts">Discounts</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>{code}</Breadcrumb.Item>
      </Breadcrumb>
      <StyledPageWrapper>
        <div className="main-area">
          <div style={{marginTop: "1.8rem"}}>
            <FormWrapper title={title}>{children}</FormWrapper>
          </div>
        </div>
        <div className="widget-area"></div>
      </StyledPageWrapper>
    </>
  );
}
